import type { BacktestExitReason } from '@fleece/models';

/**
 * How each exit reason is drawn, in one place so the chart, the legend, the donut and
 * the table agree. Take-profit and stop-loss wear the reserved status colours; expired
 * can be a win or a loss, so it takes a series colour instead; open has no outcome and is
 * muted. Every reason also has its own marker shape.
 */
export interface OutcomeStyle {
  readonly reason: BacktestExitReason;
  readonly label: string;
  readonly color: string;
  readonly shape: 'circle' | 'diamond' | 'square' | 'ring';
}

export const OUTCOMES: ReadonlyArray<OutcomeStyle> = [
  { reason: 'take_profit', label: 'Take profit', color: 'var(--good)', shape: 'circle' },
  { reason: 'stop_loss', label: 'Stop loss', color: 'var(--critical)', shape: 'diamond' },
  { reason: 'expired', label: 'Expired', color: 'var(--expired)', shape: 'square' },
  { reason: 'open', label: 'Open', color: 'var(--open)', shape: 'ring' },
];

export function outcomeStyle(reason: BacktestExitReason): OutcomeStyle {
  return OUTCOMES.find((outcome) => outcome.reason === reason) ?? OUTCOMES[3];
}
